import { shallowMount } from "@vue/test-utils";
import StepNavigator from "@/components/core/StepNavigator";

describe("StepNavigator component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(StepNavigator);
  });

  it("Renders del component StepNavigator", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
